/**
 * WritingStats — subtle footer bar: current chapter + story totals, reading
 * time, and an optional goal progress sliver. Not a productivity dashboard.
 */

import React from 'react';
import { countWords, getStoryWordCount, getReadingTime } from './utils/storyHelpers';

export default function WritingStats({ story, chapter }) {
  const chapterWords = countWords(chapter?.content);
  const totalWords = getStoryWordCount(story);
  const readingTime = getReadingTime(totalWords);
  const goal = story.goal;
  const progressPct = goal ? Math.min(100, Math.round((totalWords / goal) * 100)) : null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-line bg-card/80 px-5 py-2.5 text-[11px] text-subtle backdrop-blur" data-testid="my-writing-stats">
      <span>
        {chapterWords.toLocaleString()} words this chapter · {totalWords.toLocaleString()} total · {readingTime} min read
      </span>
      {goal && (
        <span className="flex items-center gap-2">
          <span className="h-1.5 w-24 overflow-hidden rounded-full bg-line/70">
            <span className="block h-full rounded-full bg-gradient-to-r from-coral to-yellow" style={{ width: `${progressPct}%` }} />
          </span>
          {progressPct}% of {goal.toLocaleString()}-word goal
        </span>
      )}
    </div>
  );
}
